import React from "react";
import { Modal } from 'antd';
import { Table } from 'components-shared/table/Table';
import styled from "styled-components";
// import { TableWrapper } from 'components-shared/table/TableTop';


export const TableWrapper = styled.div`
  max-height: 520px; 
  overflow-y: auto;
  margin-top: 16px;
`;

const HostedTableInfo = ({
  tableInfo,
  setTableInfo,
}) => {
  const columns = [
    {
      title: 'Column Name',
      dataIndex: 'columnName',
    },
    {
      title: 'Type',
      dataIndex: 'columnType',
    },
    {
      title: 'Is Nullable?',
      dataIndex: 'nullable',
    },
  ];

  return (
    <Modal
      className="rc-upload-hosted-lookup-table-popup"
      visible={true}
      title={`Table Structure of "${tableInfo.tableName}"`}
      onCancel={() => {
        setTableInfo({
          showTableInfo: false,
          tableName: '',
          columnDescriptions: [],
        });
      }}
      footer={null}
      maskClosable={true}
    >
      <TableWrapper>
        <Table
          columns={columns}
          data={tableInfo.columnDescriptions.map((val) => {
            return { 
              ...val,
              nullable: val.nullable === true ? 'Yes' : 'No',
            };
          })}
          rowKey="tableName"
          size="small"
          bodyStyle={{ maxHeight: '70vh', overflow: 'hidden' }} 

        />
      </TableWrapper>
    </Modal>
  );
};

export default HostedTableInfo;
